import { Component } from '@angular/core';
import { Inject} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AnexoDelegacion } from '../models/AnexoDelegacion';
import { VentanaFlotante } from '../models/VentanaFlotante';
import { DelegacionService } from '../services/bd/Delegacion/delegacion.service';
@Component({
  selector: 'ral-taller-preferente',
  templateUrl: './taller-preferente.component.html',
  styleUrls: ['./taller-preferente.component.scss']
})
export class TallerPreferenteComponent extends VentanaFlotante
{
  
  displayedColumns: string[] = ['clickable','n', 'nombre', 'direccion', 'poblacion','telefono','email'];
  //FIXME: cambiar por una funcion que realice la busqueda OK
  uMEncontradas = [
    {n:696,nombre:"UM 1 ",dirreccion:"c/La Pedriza, 107",poblacion:"Galapagar",telefono:"777888999",email:"asd@asd.com"},
    {n:2,nombre:"UM 2 ",dirreccion:"c/Agustín de Beta",poblacion:"Madrid",telefono:"777888000",email:"asdo@asdo.com"}
  ];
  
  dataSource = new MatTableDataSource(this.uMEncontradas);
  
  constructor(public override dialogRef: MatDialogRef<Component>,
              @Inject(MAT_DIALOG_DATA) public override data: TallerPreferenteData,
              private delegacionService:DelegacionService)
  {super(dialogRef, data);}

  //vuelca los datos del taller seleccionado en la ventana principal
  volcarSeleccion(element:any)
  {
    //FIXME: Tener en cuenta si no hay seleccion o si devuelve vacio/error
    //Cargamos los datod de la delegacion (unidad movil )seleccionada
    this.delegacionService.getDatosDelegacion(this.data.token,element.n)
    .then(res=>{this.dialogRef.close(res);});
  }

}
export interface TallerPreferenteData 
{
  cp: number;
  token:string;
}
